// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8153d8ac","895":"cd683766"}[chunkId] + ".chunk.js";
};